/**
 * Word categories for better organization
 */
export var WordCategory;
(function (WordCategory) {
    WordCategory["COMMON"] = "common";
    WordCategory["NOUN"] = "noun";
    WordCategory["VERB"] = "verb";
    WordCategory["ADJECTIVE"] = "adjective";
    WordCategory["ADVERB"] = "adverb";
    WordCategory["PRONOUN"] = "pronoun";
    WordCategory["PREPOSITION"] = "preposition";
    WordCategory["CONJUNCTION"] = "conjunction";
    WordCategory["INTERJECTION"] = "interjection";
    WordCategory["NUMBER"] = "number";
    WordCategory["TECHNICAL"] = "technical";
    WordCategory["NAME"] = "name";
    WordCategory["PLACE"] = "place";
})(WordCategory || (WordCategory = {}));
/**
 * Source of suggestion
 */
export var SuggestionSource;
(function (SuggestionSource) {
    SuggestionSource["DICTIONARY"] = "dictionary";
    SuggestionSource["PHONETIC"] = "phonetic";
    SuggestionSource["USER_HISTORY"] = "user";
    SuggestionSource["AUTOCORRECT"] = "autocorrect";
})(SuggestionSource || (SuggestionSource = {}));
//# sourceMappingURL=types.js.map